export default __webpack_public_path__ + "static/media/service2.cbefdd54.jpg";